import { render, staticRenderFns } from "./footGuide.vue?vue&type=template&id=69eff72e"
import script from "./footGuide.vue?vue&type=script&lang=js"
export * from "./footGuide.vue?vue&type=script&lang=js"
import style0 from "./footGuide.vue?vue&type=style&index=0&id=69eff72e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports